import { html } from "../functions/html";
import { createDialog } from "./createDialog";

export function errorDialog(error: unknown): void {
  console.error("Raising error dialog for error", error);
  const [_, content] = createDialog("Error", { autoOpen: true });

  content.innerHTML = html`
    <p>An unexpected error occurred. Reload the application or try again.</p>

    <p>The error message follows.</p>
    <pre class="error"></pre>
  `;

  const pre = content.getElementsByTagName("pre")[0];
  writeUnknown(pre, error);
}

/**
 * Prints the error message into the `<pre>` element by calling the
 * appropriate `write*` function based on the type of the value of
 * the `error` argument.
 */
function writeUnknown(pre: HTMLPreElement, error: unknown) {
  if (error === null) {
    pre.textContent += "The error object is a null value.";
  } else if (error instanceof Error) {
    writeError(pre, error);
  } else if (typeof error === "string") {
    pre.textContent += error;
  } else if (typeof error === "object") {
    writeObject(pre, error);
  } else {
    pre.textContent += `Error type: ${typeof error}\r\n`;
    pre.textContent += String(error);
  }
}

function writeError(pre: HTMLPreElement, error: Error): void {
  pre.textContent += `The error message for "${error.name}" follows:\r\n`;
  pre.textContent += error.message;
  pre.textContent += "\r\n";
  pre.textContent += "The stack trace follows:\r\n";
  pre.textContent += error.stack;
  pre.textContent += "\r\n";
  pre.textContent += "The cause follows:\r\n";
  writeUnknown(pre, error.cause);
}

function writeObject(pre: HTMLPreElement, error: object): void {
  try {
    pre.textContent += JSON.stringify(error);
  } catch {
    pre.textContent += "The error could not be serialized.\r\n";
    pre.textContent += String(error);
  }
}
